import { skillScheduleActions } from '../skillSchedules/skillSchedule-slice';
import { getData, updateItem, createItem, deleteItem } from '../common-actions';
import { fetchSkillSchedules, 
    fetchSkillSchedule, 
    createSkillSchedule as apiCreateSkillSchedule, 
    updateSkillSchedule as apiUpdateSkillSchedule, 
    deleteSkillSchedule as apiDeleteSkillSchedule} from '../../lib/api';

export const getSkillSchedules = (signal, token) => {

    return getData({
      token: token,
      actions: skillScheduleActions,
      fetchFn: (token) => fetchSkillSchedules(signal, token),
      dataKey: "skillSchedules",
      name: "get skillSchedules",
      setFunctionName: "setSkillSchedules",
      signal: signal
    });
};

export const createSkillSchedule = (token, skillSchedule, navigate) => {

    return createItem({
      token: token,
      actions: skillScheduleActions,
      createFn: apiCreateSkillSchedule,
      dataKey: "skillSchedule",
      name: "create skillSchedule",
      actionFunctionName: "createSkillSchedule",
      item: skillSchedule,
      navigate: navigate
    });
};

export const updateSkillSchedule = (token, skillSchedule) => {

    return updateItem({
      token: token,
      actions: skillScheduleActions,
      updateFn: apiUpdateSkillSchedule,
      dataKey: "skillSchedule",
      name: "update skillSchedule",
      actionFunctionName: "setSkillSchedule",
      item: skillSchedule
    });
};

export const deleteSkillSchedule = (token, skillSchedule) => {

    return deleteItem({
      token: token,
      actions: skillScheduleActions,
      deleteFn: apiDeleteSkillSchedule,
      dataKey: "skillSchedule",
      name: "delete skillSchedule",
      actionFunctionName: "deleteSkillSchedule",
      item: skillSchedule
    });
};
